import { getLocale } from "@/_services/localization"
import { formatPercentage } from "basikon-common-utils"
import React from "react"

export default class ProgressBar extends React.Component {
  handleChange = event => {
    const { onChange } = this.props
    if (onChange) onChange(event.target.value / 100)
  }

  render() {
    const { completionRate = 0, editable } = this.props

    const percentString = formatPercentage(completionRate, getLocale())
    const percent = completionRate * 100

    return editable ? (
      <>
        <label className="pull-right">{percentString}</label>
        <input type="range" className="outline-accessible" value={percent} min={0} max={100} onChange={this.handleChange} />
      </>
    ) : (
      // The text is in the text color over the track, and in white over the filler with a copy clipped to its width,
      // so that it stays readable whatever the rate
      <div className="progress-bar" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-valuetext={percentString}>
        <div className="progress-bar-filler" style={{ width: `${percent}%` }}></div>
        <div className="progress-bar-text" aria-hidden="true">
          {percentString}
        </div>
        <div className="progress-bar-text progress-bar-text-filled" style={{ clipPath: `inset(0 ${100 - percent}% 0 0)` }} aria-hidden="true">
          {percentString}
        </div>
      </div>
    )
  }
}
